import React from "react";

const BikeSvg = () => (
  <svg
    viewBox="0 0 134 87"
    css={`
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    `}
  >
    <g fillRule="evenodd" clipRule="evenodd" fill="#4CBABE">
      <path d="M81.045 61.616a5.647 5.647 0 1 1-11.293 0 5.647 5.647 0 1 1 11.293 0zM50.563 61.719C50.563 75.681 39.244 87 25.282 87 11.319 87 0 75.681 0 61.719c0-13.962 11.319-25.282 25.282-25.282 13.962 0 25.281 11.32 25.281 25.282z" />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.199 81.666c-9.755 0-17.697-7.758-17.993-17.44a13.449 13.449 0 0 0 11.356 6.231c7.432 0 13.458-6.025 13.458-13.457a13.45 13.45 0 0 0-6.181-11.324c9.645.337 17.36 8.263 17.36 17.99 0 9.94-8.059 18-18 18zM9.206 64.226A13.396 13.396 0 0 1 7.103 57c0-7.434 6.025-13.459 13.459-13.459 2.681 0 5.179.784 7.277 2.135a19.467 19.467 0 0 0-.64-.011c-9.942 0-18.001 8.06-18.001 18.001 0 .187.003.374.008.56z"
      fill="#29A4A9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.562 70.457a13.449 13.449 0 0 1-11.356-6.231 20.854 20.854 0 0 1-.008-.56c0-9.941 8.059-18.001 18.001-18.001.214 0 .427.004.64.011A13.45 13.45 0 0 1 34.02 57c0 7.432-6.026 13.457-13.458 13.457z"
      fill="#1D8B94"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M133.84 61.719C133.84 75.681 122.522 87 108.559 87S83.278 75.681 83.278 61.719c0-13.962 11.318-25.282 25.281-25.282s25.281 11.32 25.281 25.282z"
      fill="#4CBABE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M106.032 81.666c-9.942 0-18-8.06-18-18 0-9.941 8.058-18.001 18-18.001 5.642 0 10.677 2.596 13.978 6.658a13.465 13.465 0 0 0-4.7-.842c-7.45 0-13.489 6.04-13.489 13.489 0 7.448 6.039 13.487 13.489 13.487.35 0 .696-.013 1.039-.039a17.923 17.923 0 0 1-10.317 3.248zM116.349 78.418c4.646-3.255 7.684-8.649 7.684-14.752 0-4.3-1.508-8.247-4.023-11.343 5.131 1.908 8.787 6.851 8.787 12.647 0 7.098-5.485 12.917-12.448 13.448z"
      fill="#29A4A9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M115.31 78.457c-7.45 0-13.489-6.039-13.489-13.487 0-7.449 6.039-13.489 13.489-13.489 1.653 0 3.236.298 4.7.842a17.927 17.927 0 0 1 4.023 11.343c0 6.103-3.038 11.497-7.684 14.752-.343.026-.689.039-1.039.039z"
      fill="#1D8B94"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.035 19.255h49.966v-3H37.035v3z"
      fill="#E6832D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.654 18.415l21.558 43.964 2.694-1.321-21.559-43.964"
      fill="#E6832D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.959 26.615l42.104 37.748 16.3-60.83-2.897-.777L74.43 58.869 35.961 24.381l-2.002 2.234z"
      fill="#E6832D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.731 62.004L42.493 3.179h8.07v-3H40.191L23.833 61.228l2.898.776z"
      fill="#E6832D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M96.956.724a5.648 5.648 0 0 1-11.295 0h11.295z"
      fill="#4CBABE"
    />
  </svg>
);

export default BikeSvg;
